/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import React, { useState } from 'react';

function CreditLimit({
    formulaUpdated, setFormulaUpdated, params, fetchedFormula, setChangesMade,
}) {
    // const [returnparams, setReturnParams] = useState({
    //     no_of_days: '',
    // });

    const [returnparams, setReturnParams] = useState(fetchedFormula[params]);

    const InputChange = (e, index) => {
        setChangesMade(true);
        e.preventDefault();
        let prev = returnparams;
        const { id, value } = e.target;
        if (value.trim() === '') {
            prev = '';
        } else if (parseFloat(value) > 100) {
            return;
        } else {
            prev = value;
        }
        setReturnParams(prev);
        formulaUpdated[params] = prev;
        setFormulaUpdated(formulaUpdated);
    };

    return (
        <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
            <p className="text-f3 font-normal text-[#090406] pb-5">Credit Limit (%)</p>
            <div className="flex items-center -mx-0.5">
                <div className="px-0.5 w-[27%]">
                    <div className="relative w-full">
                        <input
                            type="number"
                            id="credit_limit"
                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                            autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.which === 38 || e.which === 40) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                InputChange(e);
                            }}
                            onWheel={(e) => e.target.blur()}
                            value={returnparams}
                        />
                        <label htmlFor="credit_limit" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                            Percentage
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                    <span className="font-normal text-[10px] text-[#555259] whitespace-nowrap">Percentage of threshold check at the time of placing Order</span>
                </div>
            </div>
        </div>
    );
}

export default CreditLimit;
